import {makeReducer, match} from 'web-app/util/redux';

import * as Actions from './actions';
import type * as Types from './types';

export interface ParentalPermissionsMatrixState {
    loadingPermissions: boolean;
    loadingResults: boolean;
    permissionsDescriptions: Types.PermissionDescription[];
    permissionResults: Types.PermissionResult[];
    total: number;
}

export default makeReducer<ParentalPermissionsMatrixState>(
    [
        match(Actions.fetchPermissionDescriptions, state => ({
            ...state,
            loadingPermissions: true,
        })),
        match(Actions.fetchPermissionDescriptionsSuccess, (state, {payload}) => ({
            ...state,
            loadingPermissions: false,
            permissionsDescriptions: payload.permissions,
        })),
        match(Actions.fetchPermissionDescriptionsFailed, state => ({
            ...state,
            loadingPermissions: false,
        })),
        match(Actions.fetchPermissionResults, state => ({
            ...state,
            loadingResults: true,
        })),
        match(Actions.fetchPermissionResultsSuccess, (state, {payload}) => ({
            ...state,
            loadingResults: false,
            permissionResults: payload.permissionResults,
            total: payload.total,
        })),
        match(Actions.fetchPermissionResultsFailed, state => ({
            ...state,
            loadingResults: false,
        })),
    ],
    {
        loadingPermissions: false,
        loadingResults: false,
        permissionsDescriptions: [],
        permissionResults: [],
        total: 0,
    },
);
